var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewcommonquestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 120,
    viewBox: "0 0 138 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138 76.875C138 53.0579 118.692 33.75 94.875 33.75C71.0579 33.75 51.75 53.0579 51.75 76.875C51.75 100.692 71.0579 120 94.875 120H138L125.369 107.369C133.173 99.5652 138 88.7834 138 76.875Z",
    fill: "#FE8083"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.125 0C19.3079 0 0 19.3079 0 43.125C0 55.0334 4.82677 65.8152 12.631 73.619L0 86.25H43.125C66.9421 86.25 86.25 66.9421 86.25 43.125C86.25 19.3079 66.9421 0 43.125 0Z",
    fill: "#FFC258"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewcommonquestion);
export default __webpack_public_path__ + "static/media/View common question.51217f3de33a0a2721a7dc4f9aa3289b.svg";
export { ForwardRef as ReactComponent };